<div class="login-wrapper">
  <mat-card class="m-3 pb-5">
    <mat-card-header class="login-header">
      @if (!emailSent) {
        <mat-icon class="login-avatar">lock</mat-icon>
        <h1 class="login-text text-center">
          {{ "features.forgotten_password" | transloco }}
        </h1>
      }
      @if (emailSent) {
        <mat-icon class="login-avatar">email</mat-icon>
      }
    </mat-card-header>
    <mat-card-content class="mt-3">
      @if (!emailSent) {
        <div class="loren-forgotten-password-instruction">
          {{ "forgotten_password.reset_instruction" | transloco }}
        </div>
        <loren-entity-form
          #form
          class="loren-forgotten-password-form"
          [fullLengthFields]="true"
          [formModel]="formModel"
          (submitForm)="submit($event)"
          (formFieldInteraction)="disableSubmitBtn = false"
          >
        </loren-entity-form>
        <div class="loren-forgotten-password-button-container">
          <button
            [disabled]="disableSubmitBtn"
            matButton="filled"
            class="loren-forgotten-password-button"
            color="primary"
            (click)="form.onSubmit()"
            >
            {{ "forgotten_password.send_email" | transloco }}
          </button>
        </div>
      }
      @if (emailSent) {
        <div class="w-100 text-center">
          {{ "forgotten_password.email_sent" | transloco }}
        </div>
      }
    </mat-card-content>
    <div class="loren-forgotten-password-home">
      <a [routerLink]="['/']" class="text-black-50" href="#">{{
        "home.index" | transloco
      }}</a>
    </div>
  </mat-card>
</div>
